// 接口
// @desc 接口文件
// @author 所有人
// @date 随时更新
// @example
// 先在本文件中声明“export const selectAdver = params => { return publicFn("resource/appAdver/selectAdver", params); };”，
// 需要调用接口的文件先引入import {接口名} from "@/assets/js/api";
// 接口名({参数}).then(res=>{成功回调}).catch(res=>{失败回调})
import axios from 'axios';
import $err from "@/assets/js/errcode";
import $zj from "@/assets/js/training";
import store from '@/store/index';

let wsApi = process.env.WS

window.apiurl = process.env.EXAM_HOST;
window.wsApi = wsApi;

let disabled = false; //禁止

var CancelToken = axios.CancelToken; //防止多次调用的token
var source = CancelToken.source(); //防止多次调用判断
var lastUrl = ""; //用于判断上次调的接口和本次调的接口是否相同
var numUrl = 0; //用于判断相同接口调了几次
var urlArr = [ //不做防多次点击判断的接口
  // process.env.API_HOST + "sysArea/getSomeAreas",
]
let searchServerErr = (err) => { //查询服务器错误
  for (let i = 500; i < 600; i++) {
    if (err.indexOf(`status code ${i}`) != -1) {
      return true;
    }
  }
  return false;
}



axios.interceptors.request.use(
  function (request) {
    request.headers["token"] = localStorage.getItem("token") || "";
    request.headers["reqSource"] = '3';
    if(window.localStorage.getItem("domainId")){
      request.headers["domainId"] = window.localStorage.getItem("domainId");
    }
    request.headers["version"] = '1.2.1';
    request.headers["appType"] = 0;
    if (lastUrl != request.url) {
      numUrl = 0;
    }
    lastUrl = request.url;
    numUrl++;
    if (lastUrl == request.url && numUrl > 1 && urlArr.indexOf(request.url) < 0) {
      source.cancel();
    }
    request.cancelToken = source.token;
    CancelToken = axios.CancelToken;
    source = CancelToken.source();
    return request;
  },
  function (err) {
    var error = err;
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(function (response) {
  lastUrl = "";
  numUrl = 0;
  // 对响应数据做处理
  if (response.data.message != undefined) {
    $err.errcode(response.data.message.errcode, response.data.message.errinfo);
  }
  if (response.data.data && store.state.cdnConf.length>0) {
      // 定义一个替换函数
      const replaceHttpsLinks = (data) => {
        if (typeof data === 'string' && data.indexOf("http")>=0) {
          // 如果是字符串，替换所有 HTTPS 链接
          let url = data
          store.state.cdnConf.forEach((item,i)=>{
            item.originUrl.split(",").forEach((originDomain) => {
              // 创建匹配完整域名的正则表达式
              const regex = new RegExp(`${originDomain.replace(/\./g, '\\.')}`, 'g');
              url = url.replace(regex, `${item.url}`);
            });
          })
          return url;
        } else if (typeof data === 'object' && data !== null) {
          // 如果是对象或数组，递归处理
          if (Array.isArray(data)) {
            return data.map(item => replaceHttpsLinks(item));
          } else {
            const newObj = {};
            for (const key in data) {
              newObj[key] = replaceHttpsLinks(data[key]);
            }
            return newObj;
          }
        }
        return data;
      };
      
      // 处理响应数据
      response.data = replaceHttpsLinks(response.data);
    }
  return Promise.resolve(response);
}, function (error) {
  if (axios.isCancel(error)) { // 取消请求的情况下，终端Promise调用链
    // for (let j = 0; ports[j] != undefined; j++) {
    //     clearTimeout(ports[j].timer);
    // }
    return new Promise(() => {});
  } else {
    numUrl = 0;
    // 对响应错误做处理
    if (disabled == true) return Promise.reject(error);
    if (searchServerErr(String(error))) {
      $zj.alert({
        CONTENT: "访问失败,请稍后再试",
        BACK_SUBMIT: function () {
          window.location.reload();
        }
      })
      // MessageBox('访问失败,请稍后再试', '', {
      //     confirmButtonText: '确定',
      // }).then(() => {
      //     window.location.reload();
      // }).catch(() => {
      //     return;
      // });
    }
    disabled = false;
    return Promise.reject(error);
  }
});



//调接口的封装函数
export const publicFn = (url, params, responseType, headers, contentType) => {
  // alert(123)
  // console.log(!navigator.onLine)
    if(!navigator.onLine){
      $zj.tip("网络有些问题，请稍后再试")
      // return;
    }
  return axios.post(process.env.API_HOST + url, params, responseType ? responseType : null, headers ? headers : null, contentType ? contentType : null).then(res => res.data);
}
export const gsgjjAutoLogin = params => {
  return publicFn("user/user/gsgjjAutoLogin", params);
};

//调接口的封装get函数
export const getFn = (url, query) => {
  return axios.get(process.env.API_HOST + url + (query ? '?id=' + query : '')).then(res => res.data);
}

//get请求播放器
export const getVideoUrl = (query) => {
  return getFn("class/classLibrary/findVideoPlayUrl", query)
};
//清空作弊记录
export const clearLookInfo = params => {
  return publicFn("class/user-class/clearLookInfo", params);
};

//第三方登录
// qq登录
export const qqLogin = params => {
  return publicFn("user/oauth/render/qq", params);
};
// 钉钉登录
export const dingdingLogin = params => {
  return publicFn("user/oauth/dingdingLogin", params);
};
// 钉钉快捷登陆
export const dingdingLoginCallBack = params => {
  return publicFn("user/user/dingdingLoginCallBack", params);
};
//快速选课赵腾（杨峰）
export const quickSelect = params => {
  return publicFn("class/plan-class/quick-select", params);
};
// 根据职称获取专业 — 刘艳岭
export const selectDindustryListByTitle = params => {
  return publicFn("resource/sysDictionary/selectDindustryListByTitle", params);
};
// 修改学员行业及专业 — 刘艳岭
export const updateUserIndustry = params => {
  return publicFn("user/user/updateUserIndustry", params);
};
// weixin登录
export const wechatLogin = params => {
  return publicFn("user/oauth/render/wechat", params);
};
// qq登录回调
export const qqCallBack = params => {
  return publicFn("/user/oauth/callback/qq", params);
};
// weixin登录回调
export const wechatCallBack = params => {
  return publicFn("/user/oauth/callback/wechat", params);
};
//上传用户学习笔记or学习证明--朱学禹
export const upLoadUserPlanNote = params => {
  return publicFn('plan/plan/upLoadUserPlanNote', params)
}
//保存用户学习记录or笔记--朱学禹
export const saveUserPlanExtNote = params => {
  return publicFn('plan/plan/saveUserPlanExtNote', params)
}
//保存用户学习记录or笔记--朱学禹
export const getUserPlanNote = params => {
  return publicFn('plan/plan/getUserPlanNote', params)
}
//获取用户所有站点--朱学禹
export const getUserWebSite = params => {
  return publicFn("resource/website/getUserWebSite", params);
}
//获取用户所有站点--朱学禹
export const userXinjiangWebsiteDetails = params => {
  return publicFn("resource/app/website/user-xinjiang-website-details", params);
}
// 是否设置密码
export const hasSetPwd = params => {
  return publicFn("user/user/hasSetPwd", params);
};
// 解绑
export const oauthUnBind = params => {
  return publicFn("user/user/oauthUnBind", params);
};
// 快捷注册
export const oauthRegist = params => {
  return publicFn("user/user/oauthRegist", params);
};
// 快捷登录
export const oauthLogin = params => {
  return publicFn("user/user/oauthLogin", params);
};
//快捷绑定
export const oauthBind = params => {
  return publicFn("user/user/oauthBind", params);
};
// 获取安全中心信息
export const getAccOauthInfo = params => {
  return publicFn("user/user/getAccOauthInfo", params);
};
// 修改手机号或邮箱
export const modifyTelAndEmail = params => {
  return publicFn("user/user/modifyTelAndEmail", params);
};
// 完整性检测
export const infoWholeChk = params => {
  return publicFn("user/user/infoWholeChk", params);
};

//查询地区注册信息项
export const findRegConfs = params => {
  return publicFn("user/app/user/findRegConfs", params)
}
//查询职称三级联动
export const selectParentList = params => {
  return publicFn("resource/app/title/selectParentList", params);
};
//查询学员计划上次观看信息(杨峰)
export const findPreLookInfo = params => {
  return publicFn("class/app/classLibrary/findPreLookInfo", params);
};
//查询所有职称
export const selectTitlesList = params => {
  return publicFn("resource/app/title/selectTitlesList", params);
};
//下载证书列表
export const getCertList = params => {
  return publicFn("user/app/user/getCertList", params);
};
//查询地区三级联动
export const chooseArea = params => {
  return publicFn("resource/app/area/chooseArea", params);
};
//查询地区三级联动
export const addFeedback = params => {
  return publicFn("/user/user/addFeedback", params);
};
//首页
//轮播图（聂）
export const selectAdver = params => {
  return publicFn("resource/appAdver/selectAdver", params);
};
//弹窗（杨峰）
export const selectPopupZjAdvertisement = params => {
  return publicFn("resource/appAdver/selectPopupZjAdvertisement ", params);
};
//获取课程数量（聂）
export const selectClassHourNumByType = params => {
  return publicFn("class/app/classLibrary/selectClassHourNumByType", params);
};
//获取课程根据课程类型 （聂）
export const titleRecommend = params => {
  return publicFn("class/app/classLibrary/titleRecommend", params);
};
//直播课注册
export const registUser = params => {
  return publicFn("user/app/user/registUser", params);
};
//获取地区配置课程状态（用于是否下架整个直播模块）
export const getAreaSettingClassStatus = params => {
  return publicFn("class/app/liveClass/getAreaSettingClassStatus", params);//是否展示直播图标和首页直播
};
//获取热门课程 （聂）
export const selectHotClassList = params => {
  return publicFn("class/app/classLibrary/selectHotClassList", params);
};
//获取首页直播课程 （聂）
export const selectHomeLiveClassList = params => {
  return publicFn("class/app/liveClass/selectHomeLiveClassList", params);
};
//获取直播课程列表（聂）
export const selectSecondStationLiveClassList = params => {
  return publicFn("class/app/liveClass/selectSecondStationLiveClassList", params);
};
//关注的行业 （聂）
export const queryMyFirstDictionary = params => {
  return publicFn("resource/app/sysDictionary/queryMyFirstDictionary", params);
};
//主讲人关注的行业 （聂）
export const queryMyFirstDictionaryForTeacher = params => {
  return publicFn("resource/app/sysDictionary/queryMyFirstDictionaryForTeacher", params);
};
//所有的一级行业 （聂）
export const getFirstDictionary = params => {
  return publicFn("resource/app/sysDictionary/getFirstDictionary", params);
};

//用户添加行业 （聂）
export const addFirstDictionary = params => {
  return publicFn("resource/app/sysDictionary/addFirstDictionary", params);
};
//用户添加行业 （聂）
export const deleteFirstDictionary = params => {
  return publicFn("resource/app/sysDictionary/deleteFirstDictionary", params);
};
//用户添加行业 （聂）
export const selectHotKeyWordList = params => {
  return publicFn("resource/app/dictitem/selectHotKeyWordList", params);
};
//热搜榜 （yf）
export const topList = params => {
  return publicFn("class/app/topSearch/topList", params);
};
//数据
export const selectHomePageData = params => {
  return publicFn("class/AppClass/selectHomePageData", params);
};
//学员是否有未读消息
export const isReadMsg = params => {
  return publicFn("user/app/user/isReadMsg", params);
};
//消息修改已读状态
export const updatePcMsg = params => {
  return publicFn("user/app/user/updatePcMsg", params);
};
//消息列表
export const selectMsgForUser = params => {
  return publicFn("user/app/user/selectMsgForUser", params);
};
//忽略提醒
export const closeIndustryTips = params => {
  return publicFn("user/user/closeIndustryTips", params);
};

//我的
//登录
export const loginUrl = params => {
  return publicFn("user/app/user/login", params);
};
//IOS注册
export const addUser = params => {
  return publicFn("user/app/user/v2/addUser", params);
};
//安卓注册
export const appRegist = params => {
  return publicFn("user/app/user/v2/appRegist", params);
};
export const appRegistv2 = params => {
  return publicFn("user/user/v2/regist", params);
};
//手机找回密码
export const findpswd = params => {
  return publicFn("user/app/user/findpswd", params);
};
//邮箱找回密码
export const findpswdByEmail = params => {
  return publicFn("user/app/user/findpswdByEmail", params);
};
//修改密码
export const modifyPswd = params => {
  return publicFn("user/app/user/modifyPswd", params);
};
// 验证码
export const sendCode = params => {
  return publicFn("user/user/sendCode", params);
};
export const checkCode = params => {
  return publicFn("user/user/checkCode", params);
};
//修改手机号
export const updateTel = params => {
  return publicFn("user/app/user/updateTel", params);
};
//发送注册短信
export const appSendSms = params => {
  return publicFn("user/app/user/appSendSms", params);
};
//验证验证码
export const authSms = params => {
  return publicFn("user/app/user/authSms", params);
};
//用户个人信息
export const appuserInfo = params => {
  return publicFn("user/app/user/appuserInfo", params);
};
//修改个人资料
export const editinfo = params => {
  return publicFn("user/app/user/v2/editinfo", params);
};
//获取用户单位所属地区
export const userUnitProvince = params => {
  return publicFn("user/app/user/userUnitProvince", params);
};
//单位搜索
export const checkUnit = params => {
  return publicFn("user/app/user/checkUnit", params);
};
//根据code 值查询字典详情
export const selectDictitemByCode = params => {
  return publicFn("resource/app/dictitem/selectDictitemByCode", params);
};
//优惠券列表
export const selectCouponList = params => {
  return publicFn("resource/app/coupon/login/selectCouponList", params);
};
//领取优惠券
export const selectCoupon = params => {
  return publicFn("resource/app/coupon/getCoupon", params);
};
//领取优惠券
export const getCoupon = params => {
  return publicFn("resource/app/coupon/getCoupon", params);
};
// 提交订单
export const appSettle = params => {
  return publicFn("order/app/order/appSettle", params);
};
//修改订单详情
export const updateOrderInfo = params => {
  return publicFn("order/app/order/updateOrderInfo", params);
};
export const selectBaseInfoByUserId = params => {
  return publicFn("user/user/selectBaseInfoByUserId", params);
};
export const getConfirmStatus = params => {
  return publicFn("user/user/getConfirmStatus", params);
};
export const appSettleList = params => {
  return publicFn("order/app/order/appSettleList", params);
};
export const thisCouponBindOrderPrice = params => {
  return publicFn("order/app/order/thisCouponBindOrderPrice", params);
};
//我的消息列表
export const selectMessageList = params => {
  return publicFn("news/app/message/getList", params);
};
//我的消息详情
export const selectMessageDetails = params => {
  return publicFn("news/web/pcMessage/getMessage", params);
};
//我的消息设置为已读
export const readMessage = params => {
  return publicFn("news/app/message/readMessage", params);
};
//地址列表
export const addressList = params => {
  return publicFn("user/app/user/addressList", params);
};
//新增地址
export const newAddress = params => {
  return publicFn("user/app/user/newAddress", params);
};
//查询课节试题列表 - 马山林（杨峰）
export const selectPointTmeQuestionByCuid = params => {
  return publicFn("resource/web/question/selectPointTmeQuestionByCuid", params);
};
//修改地址
export const updateAddress = params => {
  return publicFn("user/app/user/updateAddress", params);
};
//删除地址
export const delAddress = params => {
  return publicFn("user/app/user/delAddress", params);
};
//设置默认地址
export const setDefault = params => {
  return publicFn("user/app/user/setDefault", params);
};
export const saveIntelOnlineVideoForm = params => {
  return publicFn("user/user/saveIntelOnlineVideoForm", params);
};
//图片（文件）上传
export const uploadHead = params => {
  return publicFn("user/app/user/uploadHead", params);
};
//图片（文件）上传
export const uploadFeedBack = params => {
  return publicFn("user/app/user/uploadFeedBack", params);
};
// 精品课
export const checkGxPlanCanActive = params => {
  return publicFn("class/classLibrary/checkGxPlanCanActive", params);
};
// 获取cdn配置地址
export const selectCdnConf = params => {
  return publicFn("class/classLibrary/selectCdnConf", params);
};
//计划作废课程列表--朱学禹 yf
export const classNullifyList = params => {
  return publicFn("class/classLibrary/classNullifyList", params);
};
//观看视频前是否播放广告--icetea
export const feedbackeforePlayVideoInfo = params => {
  return publicFn("resource/feedback-before-play-video/getAdVideoInfo", params);
};
//精品课列表 查询
export const selectClassLibrary = params => {
  return publicFn("class/app/classLibrary/selectClassLibrary", params);
};
//精品课详情跳转
export const selectClassLibraryById = params => {
  return publicFn("class/app/classLibrary/selectClassLibraryById", params);
};
//判断精品课前台是否可见
export const selectClassLibraryIsVisible = params => {
  return publicFn("class/app/classLibrary/selectClassLibraryIsVisible", params);
};
//加入购物车
export const addShopping = params => {
  return publicFn("order/app/shopping/addShopping", params);
};
//精品课推荐课程
export const selectClassRecommend = params => {
  return publicFn("class/app/classLibrary/selectClassRecommend", params);
};

//精品课详情评价列表
export const classCommentList = params => {
  return publicFn("comment/app/comment/class-comment-page", params);
};
//精品课详情评价总星级
export const selectClassOverallCommentByCId = params => {
  return publicFn("comment/web/comment/class-comment-overall", params);
};
//删除评价
export const delComment = params => {
  return publicFn("comment/app/comment/delete-class-comment", params);
};


//学习
//培训计划列表
export const planList = params => {
  return publicFn("plan/app/plan/planList", params);
};
//培训计划规则详情
export const selectPlanRuleByIdOrUpid = params => {
  return publicFn("plan/app/plan/selectPlanRuleByIdOrUpid", params);
};
//我的计划列表
export const myPlanList = params => {
  return publicFn("plan/app/plan/myPlanList", params);
};
//我的计划详情
export const planDetail = params => {
  return publicFn("plan/plan/planDetail", params);
};
//我的课程详情
export const selectMyClassdetail = params => {
  return publicFn("class/app/classLibrary/selectMyClassdetail", params);
};
//我的计划详情
export const getUserPlanInfo = params => {
  return publicFn("class/app/classLibrary/getUserPlanInfo", params);
};
//评价列表
export const commentList = params => {
  return publicFn("comment/app/starComment/commentList", params);
};
//评价列表
export const planCommentList = params => {
  return publicFn("comment/app/comment/plan-comment-page", params);
};
//提交评价
export const classComment = params => {
  return publicFn("comment/app/comment/add-class-comment", params);
};
//计划提交评价
export const planComment = params => {
  return publicFn("comment/web/comment/add-plan-comment", params);
};
export const delPlanComment = params => {
  return publicFn("comment/app/comment/delete-plan-comment", params);
};
//修改评价
export const updateComment = params => {
  return publicFn("comment/web/comment/update-class-comment", params);
};
export const updatePlanComment = params => {
  return publicFn("comment/web/comment/update-plan-comment", params);
};
//精品课详情评价总星级
export const selectPlanOverallCommentByCId = params => {
  return publicFn("comment/web/comment/plan-comment-overall", params);
};
//学习中心
//我的计划
export const planUnAddClassList = params => {
  return publicFn("plan/app/plan/planUnAddClassList", params);
};
//用户已购且未被关联的课程列表
export const findUserPaidClass = params => {
  return publicFn("class/app/classLibrary/findUserPaidClass", params);
};
//我的课程列表
export const selectMyClassList = params => {
  return publicFn("class/app/classLibrary/selectMyClassList", params);
};
//我的课程申请证书列表
export const finishSelfClass = params => {
  return publicFn("class/app/classLibrary/finishSelfClass", params);
};
//我的课程证书配置列表
export const certConfList = params => {
  return publicFn("user/app/classCert/certConfList", params);
};
//我的课程申请证书前的校验信息
export const applyCheckInfo = params => {
  return publicFn("user/app/classCert/applyCheckInfo", params);
};
//自购课证书重新申请
export const certReApply = params => {
  return publicFn("user/app/classCert/certReApply", params);
};
//是否可以申请证书（用于是否显示申请按钮）
export const isCanApply = params => {
  return publicFn("user/app/classCert/isCanApply", params);
};
//根据证书查询证书配置
export const certConfByCertId = params => {
  return publicFn("user/app/classCert/certConfByCertId", params);
};
//我的课程申请证书
export const certApply = params => {
  return publicFn("user/app/classCert/certApply", params);
};
//查看课程certId
export const getCertClass = params => {
  return publicFn("user/app/classCert/getCertClass", params);
};
// 删除计划权限
export const delUserPlanClass = params => {
  return publicFn("class/classLibrary/delUserPlanClass", params);
};
// 删除计划权限
export const userPlanClass = params => {
  return publicFn("class/classLibrary/userPlanClass", params);
};
// 培训计划
export const planClassList = params => {
  return publicFn("plan/plan/planClassList", params);
};
// 申请开票
export const applyCertCard = params => {
  return publicFn("plan/plan/applyCertCard", params);
};
// 计划课程详情
export const selectMyPlanClassDetail = params => {
  return publicFn("class/classLibrary/selectMyPlanClassDetail", params);
};
// 集体激活后选课直接激活
export const chooseClassActive = params => {
  return publicFn("plan/plan/chooseClassActive", params);
};
// 地区系数
export const selectClassPrice = params => {
  return publicFn("class/classLibrary/selectClassPrice", params);
};
// 用户添加课程到计划
export const addUserPlanClass = params => {
  return publicFn("class/classLibrary/addUserPlanClass", params);
};
//用户添加计划
export const addUserPlan = params => {
  return publicFn("plan/plan/addUserPlan", params);
};
//计划课程是否重复添加
export const checkActivePlanClass = params => {
  return publicFn("plan/app/plan/checkActivePlanClass", params);
};
//空包激活
export const activeTheLearnBySelf = params => {
  return publicFn("plan/plan/activeTheLearnBySelf", params);
};
//全部标签
export const lableSelectParentList = params => {
  return publicFn("resource/app/lable/selectParentList", params);
};
//添加课程列表
export const userPlanAddClassList = params => {
  return publicFn("class/classLibrary/userPlanAddClassList", params);
};

//逐级选择地区
export const selectAreaChildren = params => {
  return publicFn("resource/app/area/selectAreaChildren", params);
};

//名师风采
//名师风采列表(聂)
export const selectAuthorList = params => {
  return publicFn("resource/app/author/selectAuthorList", params);
};
//名师风采详情
export const selectAuthorById = params => {
  return publicFn("resource/app/author/selectAuthorById", params);
};
//名师风采先关课程
export const recommendClass = params => {
  return publicFn("resource/app/author/recommendClass", params);
};
//名师风采推荐课程
export const authorRecommend = params => {
  return publicFn("class/app/classLibrary/authorRecommend", params);
};

//练习题
//练习题课程列表
export const selectClassByUid = params => {
  return publicFn("resource/app/question/selectClassByUid", params);
};

//考试卡
export const examineCardGetList = params => {
  return publicFn("exam/examineCard/getList", params);
};
//考试卡激活
export const examineCardActivate = params => {
  return publicFn("exam/examineCard/activate", params);
};
//考试卡申请证书
export const examineCardApplyCertCard = params => {
  return publicFn("exam/examineCard/applyCertCard", params);
};
//帮助中心
//分类列表
export const selectHelpClassifyList = params => {
  return publicFn("helpcenter/app/helpCore/selectHelpClassifyList", params);
};
export const delUserClassCheckWasBuy = params => {
  return publicFn("class/classLibrary/delUserClassCheckWasBuy", params);
};
//查看用户之前购买的订单的单位信息---朱学禹
export const getThisUserActiveType = params => {
  return publicFn("order/app/order/getThisUserActiveType", params);
};

//帮助中心列表
export const selectHelpCoreList = params => {
  return publicFn("helpcenter/app/helpCore/selectHelpCoreList", params);
};

//帮助中心详情
export const selectHelpCoreDetailList = params => {
  return publicFn("helpcenter/app/helpCore/selectHelpCoreDetailList", params);
};




//报名
//报名列表
export const serachList = params => {
  return publicFn("exam/exroom/serachList", params);
};
//报名接口
export const userApplyExroom = params => {
  return publicFn("exam/exroom/userApplyExroom", params);
};
//取消接口
export const userEscApplyExroom = params => {
  return publicFn("exam/exroom/userEscApplyExroom", params);
};
//下载接口
export const userDownFile = params => {
  return publicFn("exam/exroom/userDownFile", params);
};
//重新生成接口
export const userAgainApplyExroom = params => {
  return publicFn("exam/exroom/userAgainApplyExroom", params);
};



//考试成果接口
//考试成果培训计划列表
export const tranPlanList = params => {
  return publicFn("examination/app/trainPlan/tranPlanList", params);
};
//考试成果培训计划详情
export const tranPlanDetail = params => {
  return publicFn("examination/app/trainPlan/tranPlanDetail", params);
};
//考试成果考试卡列表
export const getExamineResult = params => {
  return publicFn("exam/app/examineCard/getExamineResult", params);
};
//行业
export const getsysDictionary = params => {
  return publicFn("/resource/app/sysDictionary/getsysDictionary", params);
};
//行业
export const getAllDictionary = params => {
  return publicFn("/resource/app/sysDictionary/getAllDictionary", params)
}


//购物车列表
export const shoppingList = params => {
  return publicFn("order/app/shopping/shoppingList", params);
};
//删除购物车
export const deleteShopping = params => {
  return publicFn("/order/app/shopping/deleteShopping", params);
};

//订单
//可补开发票
export const orderDetailByOrderNum = params => {
  return publicFn("order/app/order/orderDetailByOrderNum", params);
};
export const orderCheckForPay = params => {
  return publicFn("order/web/order/orderCheckForPay", params);
};
//卡号激活
export const cardActivate = params => {
  return publicFn("order/app/order/cardActivate", params);
};
export const supplementInvoiceInfoList = params => {
  return publicFn("order/app/order/supplementInvoiceInfoList", params);
};
export const insertSuppleInvoice = params => {
  return publicFn("order/app/order/insertSuppleInvoice", params);
};
export const canSupplementInvoiceList = params => {
  return publicFn("order/app/order/canSupplementInvoiceList", params);
};
export const orderRefund = params => {
  return publicFn("order/app/order/orderRefund", params);
};
export const postInovice = params => {
  return publicFn("order/app/order/postInovice", params);
};
export const orderCancel = params => {
  return publicFn("order/app/order/orderCancel", params);
};
export const isUnitChange = params => {
  return publicFn("order/app/order/isUnitChange", params);
};
export const supplementInvoiceList = params => {
  return publicFn("order/app/order/supplementInvoiceList", params);
};
export const myOrderList = params => {
  return publicFn("order/app/order/myOrderList", params);
};
export const checkInviteCodeIsAlive = params => {
  return publicFn("user/app/user/checkInviteCodeIsAlive", params);
};
export const getAreaInviteCodeIsNeed = params => {
  return publicFn("user/app/user/getAreaInviteCodeIsNeed", params);
};
export const scanInviteCode = params => {
  return publicFn("user/user/scanInviteCode", params);
};

//直播详情页接口
//直播课课程详情——汪德宇
export const getLiveClassInfo = params => {
  return publicFn("class/app/liveClass/getLiveClassInfo", params);
};
//获取直播/点播/相关 课程推荐——汪德宇
export const getLiveOrPointClassRecommend = params => {
  return publicFn("class/app/liveClass/getLiveOrPointClassRecommend", params);
};
//获取课节列表——汪德宇
export const getLiveClassLessonList = params => {
  return publicFn("class/app/liveClass/getLiveClassLessonList", params);
};
//是否可以进直播间——汪德宇
export const isCanIntoLiveClassRoom = params => {
  return publicFn("class/app/liveClass/isCanIntoLiveClassRoom", params);
};
//判断是否能评论该课程——汪德宇
export const whetherCanComment = params => {
  return publicFn("comment/app/comment/whetherCanComment", params);
};
//直播提醒验证手机号——汪德宇
export const liveClassRemindCheckTel = params => {
  return publicFn("class/app/liveClass/liveClassRemindCheckTel", params);
};
//直播提醒/关闭提醒——汪德宇
export const liveClassRemind = params => {
  return publicFn("class/app/liveClass/liveClassRemind", params);
};
//自购课》直播课列表——汪德宇
export const getAlreadyBuyOfLiveClassList = params => {
  return publicFn("class/app/liveClass/getAlreadyBuyOfLiveClassList", params);
};
//获取直播课地址——汪德宇
export const getLiveRoomUrl = params => {
  return publicFn("class/app/liveClass/getLiveRoomUrl", params);
};
//禁止开票温馨提示
export const promptWarm = params => {
  return publicFn("resource/prompt/warm", params);
};
//禁止开票弹窗
export const promptAlter = params => {
  return publicFn("resource/prompt/alter", params);
};
//获取用户授权信息——汪德宇 2020年终活动的
export const getUserActivityAuthInfo = params => {
  return publicFn("resource/activity/2020-year-end/getUserActivityAuthInfo", params);
};
//活动页面获取用户活动数据——icetea 2020年终活动的
export const userActivityInfo = params => {
  return publicFn("resource/activity/2020-year-end/user-activity-info", params);
};
//活动页面-记录访问操作——icetea 2020年终活动的
export const dataBurying = params => {
  return publicFn("resource/activity/2020-year-end/data-burying", params);
};
//活动页面-反馈内容——icetea 2020年终活动的
export const feedback = params => {
  return publicFn("resource/activity/2020-year-end/feedback", params);
};
//河南 档案管理
export const studyResultList = params => {
  return publicFn("plan/app/plan/studyResultList", params);
};
//获取监管规则
export const getTrainSupervision = params => {
  return publicFn("resource/tpAccess/external/getTrainSupervision ", params);
};
//从管理平台获取验证码
export const getVerificationCode = params => {
  return publicFn("resource/tpAccess/external/getVerificationCode", params);
};
//机构培训平台向管理平台发送验证结果
export const sendCodeAnswer = params => {
  return publicFn("resource/tpAccess/external/sendCodeAnswer", params);
};

// 观看记录详情列表——汪德宇
export const queryFaceArchives = params => {
  return publicFn("user/app/user/queryFaceArchives", params);
};
// 观看记录详情列表——汪德宇
export const insertFaceDatabase = params => {
  return publicFn("user/app/user/insertFaceDatabase", params);
};
// 观看记录详情列表——汪德宇
export const userFaceMatchForLearn = params => {
  return publicFn("user/app/user/userFaceMatchForLearn", params);
};
//插入视频抓拍记录-闫培
export const uploadCapturePicturesInfo = params => {
  return publicFn("user/user/uploadCapturePicturesInfo", params);
};
//插入视频抓拍记录-闫培
export const uploadBase64Picture = params => {
  return publicFn("user/user/uploadBase64Picture", params);
};
//插入视频抓拍记录-闫培
export const capturePicturesInfo = params => {
  return publicFn("user/user/capturePicturesInfo", params);
};
//插入视频抓拍记录-闫培
export const uploadPicture = params => {
  return publicFn("user/user/uploadPicture", params);
};
//插入视频抓拍记录-闫培
export const getPerCtg = params => {
  return publicFn("resource/bjcyjzgl/get-per-ctg", params);
};
// 庆阳评价
export const qingYangComment = params => {
  return publicFn("comment/web/comment/qingYangComment", params);
};
// 判断用户是否在某时间段计划学习合格
export const selectUserPlanIsQualified = params => {
  return publicFn("plan/plan/selectUserPlanIsQualified", params);
};
// 查询订单退款详情
export const queryOrderRefund = params => {
  return publicFn("order/app/order/queryOrderRefund", params);
};

// 取消退款
export const cancelOrderRefund = params => {
  return publicFn("order/app/order/cancelOrderRefund", params);
};
// 获取学员历史开票信息接口，方便学员填写发票信息
export const getSuppleInvoiceHistory = params => {
  return publicFn("order/web/order/getSuppleInvoiceHistory", params);
};

// 自购课订单可退款商品列表-苗海峰
export const getOrderCanRefundClassList = params => {
  return publicFn("order/web/order/getOrderCanRefundClassList", params);
};
// 自购课订单可退款商品列表-苗海峰
export const getRefundOrderList = params => {
  return publicFn("order/web/order/getRefundOrderList", params);
};
// 获取用户自购课订单中可重新购买的课程列表
export const getOrderCanReOrderClassList = params => {
  return publicFn("order/app/order/getOrderCanReOrderClassList", params);
};

//直播课申请证书
export const liveCertApply = params => {
  return publicFn("class/liveClass/liveCertApply", params);
};
export const liveLookInfo = params => {
  return publicFn("class/app/liveClass/liveLookInfo", params);
};

// 继续学习接口
export const buySelfClassByUnitPay = params => {
  return publicFn("order/web/order/buySelfClassByUnitPay", params);
};
//自购课集体线下支付——汪德宇
export const checkUserCanPayWithUnit = params => {
  return publicFn("order/web/order/checkUserCanPayWithUnit", params);
};
// 自购课订单取消单位支付-苗海峰
export const cancelSelfClassOrderForUnitPay = params => {
  return publicFn("order/web/order/cancelSelfClassOrderForUnitPay", params);
};

export const selectNotRemarkWebSite = params => {
  return publicFn("resource/app/website/selectNotRemarkWebSite", params);
};

export const getLzDesignIndustryForHomePage = params => {
  return publicFn("plan/plan/getLzDesignIndustryForHomePage", params);
};

export const getLzDesignIndustryPlanInfo = params => {
  return publicFn("plan/plan/getLzDesignIndustryPlanInfo", params);
};

export const getLzDesignIndustryWithPlan = params => {
  return publicFn("plan/app/plan/getLzDesignIndustryWithPlan", params);
};

export const checkUserXzExist = params => {
  return publicFn("user/user/checkUserXzExist", params);
};
export const reqGet = params => {
  return publicFn("user/captcha/get", params,);
};
export const reqCheck = params => {
  return publicFn("user/captcha/check", params,);
};
export const unionPay = params => {
  return publicFn("/order/web/order/unionpay", params,);
};
export const selectOrderPayStateByOrderNum = params => {
  return publicFn("/order/web/order/selectOrderPayStateByOrderNum", params,);
};
export const getUnionPayFlag = params => {
  return publicFn("/resource/website/getUnionPayFlag", params,);
}
//下载发票
export const downLoadInvoice = params => {
  return publicFn("order/web/order/downLoadInvoice", params,{ responseType: 'blob' });
};
// 根据订单号查询优惠券是否已过期
export const isCouponValid = params => {
  return publicFn("order/web/order/isCouponValid", params);
};
// 获取固定课程
export const selectClassdetailByIds = params => {
  return publicFn("class/classLibrary/selectClassdetailByIds", params);
};
// 获取固定课程详情
export const selectClassDetailById = params => {
  return publicFn("class/classLibrary/selectClassDetailById", params);
};

// 计划下载证书校验
export const plNeedComment = params => {
  return publicFn("resource/pl/commert/need-comment", params);
};
// 平凉添加评价
export const plCommertAdd = params => {
  return publicFn("resource/pl/commert/add", params);
};
//编辑学会计划现在合格证书
export const downloadPlanImgCert = params => {
  return publicFn("user/user/downloadPlanImgCert", params,{ responseType: 'blob' })
};



// WEBPACK FOOTER //
// ./src/assets/js/api.js